// extracted by mini-css-extract-plugin
module.exports = {"contentMain":"LegalNotice_contentMain__3qOBv","legalNoticeContent":"LegalNotice_legalNoticeContent__3yQsZ"};